// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__YoBB8","requiredAsterisk":"Info_requiredAsterisk__3d8tI"};